import React from 'react';
import SkeletonCustom from 'Components/common/skeleton/SkeletonCustom';

/**
 * Shown only in the main content area when a lazy page chunk is still loading.
 * Kept outside App so layout/sidebar from PrivateWrapper stay visible.
 */
const RouteOutletSuspenseFallback = function RouteOutletSuspenseFallback() {
  return (
    <div className="route-outlet-suspense-fallback" style={{ minHeight: '50vh', padding: '8px 0' }}>
      <SkeletonCustom
        width="100%"
        height="32px"
        margin="0 0 16px 0"
      />
      <SkeletonCustom
        width="100%"
        height="200px"
        margin="0 0 12px 0"
      />
      <SkeletonCustom
        width="100%"
        height="160px"
        margin="0 0 12px 0"
      />
      <SkeletonCustom
        width="78%"
        height="120px"
        margin="0"
      />
    </div>
  );
};

export default RouteOutletSuspenseFallback;
